import API_URLS from "@constants/apiUrls";
import { api } from "services/customBaseQuery";

// ============================================================================
// Types
// ============================================================================
interface FetchExpiryReminderHistoryParams {
  page?: number;
  page_size?: number;
  status?: string;
  q?: string;
  [key: string]: any;
}

interface ReminderHistoryItem {
  id: number;
  user_id: number;
  user_name: string;
  user_email: string;
  reminder_type: string;
  sent_at: string;
  status: string;
  expiry_date: string;
}

interface FetchExpiryReminderHistoryResponse {
  data: ReminderHistoryItem[];
  total_page: number;
  current_page: number;
  total_count: number;
  current_page_count?: number;
}

interface SendExpiryReminderRequest {
  credit_id:any;
}

interface SendExpiryReminderResponse {
  message: string;
  success: boolean;
  data?: any;
}

// ============================================================================
// API Endpoints
// ============================================================================
export const sendReminderAPI = api.injectEndpoints({
  endpoints: (build) => ({
    /**
     * Fetches expiry reminder history with pagination and filters
     */
    fetchExpiryReminderHistory: build.query<
      FetchExpiryReminderHistoryResponse,
      FetchExpiryReminderHistoryParams
    >({
      query: (params) => {
        const queryString = params
          ? `?${new URLSearchParams(params as any).toString()}`
          : "";
        return {
          url: `${API_URLS.EXPIRY_REMINDER}${queryString}`,
          method: "GET",
          credentials: "include",
        };
      },
      keepUnusedDataFor: 0,
    }),

    /**
     * Sends expiry reminder to selected users
     */
    sendExpiryReminder: build.mutation<
      SendExpiryReminderResponse,
      SendExpiryReminderRequest
    >({
      query: (data) => ({
        url: API_URLS.SEND_REMINDER,
        method: "POST",
        body: data,
        credentials: "include",
      }),
    }),
  }),
});

// ============================================================================
// Exports
// ============================================================================
export const {
  useFetchExpiryReminderHistoryQuery,
  useLazyFetchExpiryReminderHistoryQuery,
  useSendExpiryReminderMutation,
} = sendReminderAPI;

export type {
  FetchExpiryReminderHistoryParams,
  FetchExpiryReminderHistoryResponse,
  SendExpiryReminderRequest,
  SendExpiryReminderResponse,
  ReminderHistoryItem,
};